import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Dashboard() {
  const [odds, setOdds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch odds from backend
    axios.get('http://localhost:5000/api/odds')
      .then(response => {
        setOdds(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching odds:', error);
        setError('Failed to load odds');
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Loading odds data...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div style={{ padding: '40px', maxWidth: '1200px', margin: '0 auto' }}>
      <h1>Live Odds Dashboard</h1>
      
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
        <thead>
        <tr style={{ borderBottom: '2px solid #333' }}>
            <th style={{ padding: '10px', textAlign: 'left' }}>Game</th>
            <th style={{ padding: '10px', textAlign: 'left' }}>Sport</th>
            <th style={{ padding: '10px', textAlign: 'left' }}>Time</th>
            <th style={{ padding: '10px', textAlign: 'left' }}>Book</th>
            <th style={{ padding: '10px', textAlign: 'left' }}>Bet</th>
            <th style={{ padding: '10px', textAlign: 'left' }}>Price</th>
            <th style={{ padding: '10px', textAlign: 'left' }}>EV</th>
        </tr>
        </thead>
        <tbody>
        {odds.map((row, index) => (
            <tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
            <td style={{ padding: '10px' }}>{row.home_team} vs {row.away_team}</td>
            <td style={{ padding: '10px' }}>{row.sporttitle}</td>
            <td style={{ padding: '10px' }}>{new Date(row.commencetime).toLocaleString()}</td>
            <td style={{ padding: '10px' }}>{row.bookmakerid}</td>
            <td style={{ padding: '10px' }}>{row.bet_name}</td>
            <td style={{ padding: '10px' }}>{row.price}</td>
            <td style={{ padding: '10px' }}>{row.ev}%</td>
            </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
}

export default Dashboard;